import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  tableCell: {
    padding: "10px",
    borderBottom: "1px solid #363636",
    "&:hover": {
      backgroundColor: "#363636",
    },
    color: "#ffffff",
  },
  tabWrapper: {
    borderRadius: "30px",
    border: "1px solid #FF68D5",
    color: "#FF68D5",
  },
  tab: {
    color: "#FF68D5",
    fontWeight: 600,
  },
  activeTab: {
    color: "white",
    backgroundColor: "#FF68D5",
    fontWeight: "bold",
    borderRadius: "30px",
    "&:focus": {
      outline: "none",
    },
    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },
  mobileSearchInput: {
    position: "absolute",
    // top: "56px",
    left: "80%",
    transform: "translateX(-50%)",
    zIndex: 999,
    display: "flex",
    alignItems: "center",
    borderRadius: "30px",
    backgroundColor: "#1f1f1f",
    border: "1px solid #363636",
    padding: "0 16px",
    height: "40px",
    maxWidth: "135px",
    width: "90%",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },
  pageContainer: {
    maxWidth: "1190px",
    margin: "0 auto",
    width: "100%",
  },
  tableContainer: {
    overflowX: "auto",
    width: "100%",
    "&::-webkit-scrollbar": {
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#1a1a1a",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#363636",
      borderRadius: "4px",
      "&:hover": {
        background: "#555",
      },
    },
  },
  paginationRoot: {
    color: "#fff",
    borderTop: "1px solid #363636",
  },
  paginationCaption: {
    color: "rgba(255,255,255,0.8)",
  },
  paginationSelectIcon: {
    color: "#fff",
  },
  menuPaper: {
    background: "#121212",
    color: "#fff",
  },
}));

export default useStyles;
